import { campaignService } from './campaignService';
import { useFetchCampaigns } from './useFetchCampaigns';

const FUNDRAISER_PAGE_SIZE = 15;

export const useFundraiserCampaigns = (userId?: number) => {
  return useFetchCampaigns(page => campaignService.fetchCampaigns(page, FUNDRAISER_PAGE_SIZE, userId, 'ACTIVE'));
};
